import StatefulBreadcrumb from './StatefulBreadcrumb';

export default StatefulBreadcrumb;
